import React from 'react';
import { useNavigate } from 'react-router-dom';

interface ViewLayoutProps {
  title: string;
  subtitle?: string;
  isLoading?: boolean;
  children: React.ReactNode;
  onBack?: () => void;
  backButtonText?: string;
  showActions?: boolean;
  entityId?: string | number;
  editUrl?: string;
  onEdit?: () => void;
  onDelete?: () => void;
  deleteButtonText?: string;
  additionalActions?: React.ReactNode;
}

const ViewLayout: React.FC<ViewLayoutProps> = ({
  title,
  subtitle,
  isLoading = false,
  children,
  onBack,
  backButtonText = 'Voltar',
  showActions = true,
  entityId,
  editUrl,
  onEdit,
  onDelete,
  deleteButtonText = 'Excluir',
  additionalActions
}) => {
  const navigate = useNavigate();

  const handleBack = () => {
    if (onBack) {
      onBack();
    } else {
      navigate(-1);
    }
  };

  const handleEdit = () => {
    if (onEdit) {
      onEdit();
    } else if (editUrl) {
      navigate(editUrl);
    }
  };

  const handleDelete = () => {
    if (onDelete) {
      if (window.confirm(`Tem certeza que deseja ${deleteButtonText.toLowerCase()} este item?`)) {
        onDelete();
      }
    }
  };

  if (isLoading) {
    return (
      <div className="page-container">
        <div className="page-header">
          <button className="btn btn-secondary" onClick={handleBack} disabled={isLoading}>
            <i className="fas fa-arrow-left"></i>
            {backButtonText}
          </button>
          <div>
            <h1>Carregando...</h1>
            {subtitle && <p className="text-muted">{subtitle}</p>}
          </div>
        </div>
        <div style={{ textAlign: 'center', padding: '100px 20px' }}>
          <div className="loading-spinner-large"></div>
          <p>Carregando dados...</p>
        </div>
      </div>
    );
  }

  return (
    <div className="page-container">
      <div className="page-header">
        <button className="btn btn-secondary" onClick={handleBack} disabled={isLoading}>
          <i className="fas fa-arrow-left"></i>
          {backButtonText}
        </button>
        <h1>{title}</h1>
        <div className="header-actions">
          {editUrl || onEdit ? (
            <button
              className="btn btn-primary"
              onClick={handleEdit}
              disabled={isLoading}
            >
              <i className="fas fa-edit"></i>
              Editar
            </button>
          ) : null}
          {additionalActions}
        </div>
      </div>

      <div className="page-content">
        <div className="card">
          <div className="card-header">
            <h2>{subtitle}</h2>
            {entityId && <span className="text-muted">ID: {entityId}</span>}
          </div>
          
          <div className="card-body">
            {children}
          </div>
        </div>

        {showActions && (editUrl || onEdit || onDelete) && (
          <div style={{ marginTop: '20px', display: 'flex', gap: '10px', justifyContent: 'flex-end' }}>
            <button
              className="btn btn-secondary"
              onClick={handleBack}
              disabled={isLoading}
            >
              <i className="fas fa-list"></i>
              {backButtonText}
            </button>
            {editUrl || onEdit ? (
              <button
                className="btn btn-primary"
                onClick={handleEdit}
                disabled={isLoading}
              >
                <i className="fas fa-edit"></i>
                Editar
              </button>
            ) : null}
            {onDelete ? (
              <button
                className="btn btn-danger"
                onClick={handleDelete}
                disabled={isLoading}
              >
                <i className="fas fa-trash"></i>
                {deleteButtonText}
              </button>
            ) : null}
          </div>
        )}
      </div>
    </div>
  );
};

export default ViewLayout;
